// extracted by mini-css-extract-plugin
module.exports = {"link":"_93444fe79c--link--vounM"};